"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeCustomers_en_us = void 0;
function backofficeCustomers_en_us() {
    return {
        "backoffice.customers.header": "Customers",
        "backoffice.customers.subtitle": "Manage your customers",
        "backoffice.customers.createbtn": "Create Customer",
        "backoffice.customers.fields.email": "Email",
        "backoffice.customers.fields.displayname": "Display Name",
        "backoffice.customers.fields.createdat": "Created At",
        "backoffice.customers.remove.title": "Remove customer",
        "backoffice.customers.remove.confirmation": "Do you really want to delete this customer? You will lose all references to this customer in the entire system, including orders, links and messages. Please only delete customers if you know, what you're doing!",
        "backoffice.customers.setpassword.title": "Set Password",
        "backoffice.customers.configuration.formtitle": "New Registrations blocked",
        "backoffice.customers.configuration.title": "Customer Registration",
        "backoffice.customers.configuration.content": "In case you have a fixed number of customers or the customer registration process follows a separate registration flow, you can block any further registrations."
    };
}
exports.backofficeCustomers_en_us = backofficeCustomers_en_us;
